import {twMerge} from '../../../common/twMerge';
import {Icon} from '../Icon/Icon';
import {IconType} from '../Icon/IconType.enum';
import {StaticImage} from '../StaticImage/StaticImage';
import {SeparatorProps} from './SeparatorProps.interface';
import {SeparatorType} from './SeparatorType.enum';

export function Separator({
  type = SeparatorType.Line,
  useStaticDot,
  className,
  ...props
}: SeparatorProps) {
  return (
    <>
      {type === SeparatorType.Line && (
        <div className={twMerge('inline-block w-1pxr', className)} {...props} />
      )}
      {type === SeparatorType.Dot && (
        <StaticImage
          className={twMerge('inline', className)}
          imageType={
            useStaticDot
              ? IconType.ListMetadataDotStatic
              : IconType.ListMetadataDot
          }
          {...props}
        />
      )}
      {type === SeparatorType.ContentHomeLine && (
        <Icon
          className={twMerge('inline', className)}
          type={IconType.ContentHomeDivider}
          disableActiveEffect
          {...props}
        />
      )}
      {type === SeparatorType.ContentHomeListLine && (
        <Icon
          className={twMerge('inline', className)}
          type={IconType.ContentHomeListDivider}
          disableActiveEffect
          {...props}
        />
      )}
      {type === SeparatorType.ContentHomeDot && (
        <Icon
          className={twMerge('inline', className)}
          type={IconType.ContentHomeDot}
          disableActiveEffect
          {...props}
        />
      )}
    </>
  );
}
